module.exports = __webpack_public_path__ + "img/Certification_check_ic_normal.f26f319.svg";